module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHZpZXdCb3g9IjAgMCA2IDYiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBmaWxsPSIjMzVENkVEIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjAgLTM0OSkgdHJhbnNsYXRlKDMwIDIzMSkgdHJhbnNsYXRlKDMwIDEwOSkiPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjMiIGN5PSIxMiIgcj0iMyIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/oval.svg
// module id = aBKR
// module chunks = 28